var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wf-article-previous-next" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "wf-article-previous-next-content" }, [
        _vm.previousArticle.nodeAliasPath
          ? _c("div", [
              _c(
                "a",
                {
                  staticClass: "wf-article-previous",
                  attrs: { href: _vm.previousArticle.nodeAliasPath }
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "wf-article-previous-next-item" }, [
                    _c(
                      "div",
                      {
                        staticClass: "wf-article-previous-next-mobile-caption"
                      },
                      [_vm._v("\n              Previous:\n            ")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "secondary-heading" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.previousArticle.category) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "h3 mb-0" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.previousArticle.title) +
                          "\n            "
                      )
                    ])
                  ])
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.nextArticle.nodeAliasPath
          ? _c("div", [
              _c(
                "a",
                {
                  staticClass: "wf-article-next",
                  attrs: { href: _vm.nextArticle.nodeAliasPath }
                },
                [
                  _c("div", { staticClass: "wf-article-previous-next-item" }, [
                    _c(
                      "div",
                      {
                        staticClass: "wf-article-previous-next-mobile-caption"
                      },
                      [_vm._v("\n              Next:\n            ")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "secondary-heading" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.nextArticle.category) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "h3 mb-0" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.nextArticle.title) +
                          "\n            "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(1)
                ]
              )
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wf-article-previous-next-nav-button" }, [
      _c("span", {
        staticClass: "png-icon png-icon-icons-glyph--k-chevron-left"
      }),
      _vm._v("\n            Prev\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wf-article-previous-next-nav-button" }, [
      _c("span", {
        staticClass: "png-icon png-icon-icons-glyph--k-chevron-right"
      }),
      _vm._v("\n            Next\n          ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }